import { Box, TextField, MenuItem, Typography } from "@mui/material";

const SaleInvoiceHeader = ({ data, onChange }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Invoice Header</Typography>
      <TextField
        label="Invoice No"
        value={data.invoiceNo}
        onChange={(e) => onChange("invoiceNo", e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Invoice Date"
        type="date"
        value={data.invoiceDate}
        onChange={(e) => onChange("invoiceDate", e.target.value)}
        InputLabelProps={{ shrink: true }}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Tax Type"
        select
        value={data.taxType}
        onChange={(e) => onChange("taxType", e.target.value)}
        fullWidth
      >
        <MenuItem value="IGST">IGST</MenuItem>
        <MenuItem value="SGST_CGST">SGST/CGST</MenuItem>
      </TextField>
    </Box>
  );
};

export default SaleInvoiceHeader;